import { DesktopHeader } from '@kanda-libs/ks-design-library';

import { SubscriptionNotice } from './components';
import Container from './DesktopHeader-container';

const ViewComponent = (props) => (
  <Container>
    {({
      isLoading,
      logout,
      showNotice,
      companyItems,
      items,
      showHelpModal,
    }) => (
      <div className="z-50 flex flex-1 w-full">
        <DesktopHeader
          isLoading={isLoading}
          companyName="My Account"
          companyItems={companyItems}
          logout={logout}
          items={items}
          notice={showNotice ? SubscriptionNotice : undefined}
          help={showHelpModal}
          {...props}
        />
      </div>
    )}
  </Container>
);

ViewComponent.displayName = 'DesktopHeader-view';

export default ViewComponent;
